import {ReactSession} from "react-client-session";
import {AES, enc} from "crypto-js";
import Header from "./Header";
import {useState, useEffect, Suspense} from "react";
import ApiRequester from "./ApiRequester";
import {
    sortFunc, isBannerPresent
} from "../libs";
import {ToastContainer} from "react-toastify";
import Footer from "./Footer";
import TableHeaders from "./component-assets/TableHeaders";
import CampusDropDown from "./component-assets/CampusDropDown";
import TableBody from "./component-assets/TableBody";
import Navigation from "./Navigation";
import SessionReload from "./component-assets/SessionReload";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton";


const TasksMaint = (props) => {

    let dData, headerData, csvHeaders;

    headerData = [
        {label: "Detected", key: "event_datetime_utc", align: "center", type: "datetime-utc"},
        {label: "Duration", key: "event_datetime_utc", align: "center", type: "duration"},
        {label: "Condition", key: "condition", align: "center"},
        {label: "Device / Serial", key: ["device_name", "manufacture_uuid"], align: "center",
            link: {enabled: true, type: "conditional-stack", conditionKey: "manufacture_id",
                condition: {
                    1: {linkto: "/profiles/inovonics", linkkey: "device_id"},
                    4: {linkto: "/profiles/palcare", linkkey: "device_id"}
                }}},
        {label: "Area", key: "area_name", align: "center",
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Resident", key: "resident_name", align: "center",
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}}
    ];

    csvHeaders = [
        {label: "Detected (UTC)", key: "event_datetime_utc"},
        {label: "Condition", key: "condition"},
        {label: "Device Name", key: "device_name"},
        {label: "Device Serial #", key: "manufacture_uuid"},
        {label: "Area", key: "area_name"},
        {label: "Resident", key: "resident_name"}
    ];

    if (ReactSession.get("PAL") != null){
        let bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    const [dataOrigin, setDataOrigin] = useState([]);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [sorter, setSorter] = useState({
        sortColumn: "event_datetime_utc",
        sortOrder: "asc"
    });
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);

    useEffect(() => {
        let interval;
        interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": true,
                                procedure: "getdevicemaintenance", reqType: "stored"}).then(data => {
                setDataOrigin(data ? data : []);
                setOriginLoaded(true);
            })
            setCount((count) => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        setActiveData(dataOrigin);
    }, [dataOrigin]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        if (activeData?.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={0} end={activeData?.length ? activeData.length : 0} tableData={activeData}
                                checkbox={false} writeAccess={false} unk={"a-"} checkidkey={""}
                                actionAppearance={() => {}} tableHeaders={headerData} editModal={() => {}}
                                parentComponent={"Alerts"} dData={dData} checkboxlist={[]} setCheckboxId={() => {}}
                                tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)} />);
    }, [activeData, sorter, count]);

    const tableHeaders = <TableHeaders checkbox={false} headerData={headerData} sortOrder={sorter.sortOrder}
                                       borderBuffer={true} sortColumn={sorter.sortColumn} sorter={sorter}
                                       setSorter={setSorter} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <CampusDropDown campusId={campusId}
                            setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={(e) => {
                                setOriginLoaded(false);
                                setPageLoaded(false);
                                if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                                    window.location.reload()
                                }
                            }} />
        </div>
    );
    return (
        <>
            {dData?.migrated && <SessionReload />}
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Tasks 5.0"} Title={"Maintenance"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={"row"}>
                        {!pageLoaded
                        ?   skeleton
                        :   <table className={"table table-sm table-white table-hover"}>
                                <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                {tableRows}
                                </tbody>
                            </table>
                    }
                    </div>
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer/>
                <Suspense fallback={"Loading..."}>
                    <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                    autoClose={10000} closeOnClick={true}/>
                </Suspense>
            </div>
        </>
    );
};

export default TasksMaint;